import React from 'react';
import useToastStore from '../store/useToastStore';

const TYPE_STYLES = {
  success: {
    border: 'border-l-4 border-l-green-500',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
  },
  error: {
    border: 'border-l-4 border-l-red-500',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    ),
  },
  info: {
    border: 'border-l-4 border-l-brand-purple',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6C5CE7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    ),
  },
  warning: {
    border: 'border-l-4 border-l-yellow-400',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#facc15" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
  message: {
    border: 'border-l-4 border-l-brand-purple',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6C5CE7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
      </svg>
    ),
  },
};

export default function Toast() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `}</style>

      <div
        className="fixed bottom-24 left-0 right-0 z-50 flex flex-col items-center gap-2 px-4 pointer-events-none"
      >
        {[...toasts].reverse().map((toast) => {
          const styles = TYPE_STYLES[toast.type] || TYPE_STYLES.info;
          return (
            <div
              key={toast.id}
              style={{ animation: 'slideUp 0.25s ease-out', maxWidth: '340px', width: '100%' }}
              className={`pointer-events-auto bg-dark-surface border border-dark-border rounded-2xl px-4 py-3 flex items-center gap-3 shadow-lg ${styles.border} ${toast.onClick ? 'cursor-pointer active:opacity-70' : ''}`}
              onClick={toast.onClick ? () => { toast.onClick(); removeToast(toast.id); } : undefined}
            >
              <span className="flex-shrink-0">{styles.icon}</span>
              <p className="flex-1 text-dark-text text-sm leading-snug">{toast.message}</p>
              <button
                onClick={(e) => { e.stopPropagation(); removeToast(toast.id); }}
                className="flex-shrink-0 text-dark-subtext hover:text-dark-text transition-colors text-lg leading-none"
                aria-label="Dismiss"
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
}
